import { Button, Typography } from '@scale/scaleui';
import React, { useCallback } from 'react';
import { twMerge } from 'tailwind-merge';

type InputProps = {
  label: string | JSX.Element;
  component: JSX.Element;
  fullWidth?: boolean;
};

export const SlidingDrawer: React.FC<{
  canSave?: boolean;
  onOutsideClick?: () => void;
  component?: React.ReactNode;
  open: boolean;
  onClose: () => void;
  inputs?: InputProps[];
  disableButtons: boolean;
  allowDelete: boolean;
  saveButtonText?: string;
  onSave?: () => void;
  onDelete?: () => void;
  width: string;
}> = ({
  canSave = true,
  component,
  open,
  onClose,
  onOutsideClick,
  inputs,
  disableButtons,
  allowDelete,
  onSave,
  onDelete,
  saveButtonText,
  width,
}) => {
  const closeModal = useCallback(() => {
    onClose();
  }, [onClose]);

  const renderInputField = (props: InputProps) => {
    const { label, component, fullWidth } = props;
    return !fullWidth ? (
      <div className="grid-cols-3 grid" key={label.toString()}>
        <div className="flex my-auto">
          <Typography.Subtitle3 className="col-span-1">{label}</Typography.Subtitle3>
        </div>
        <div className="col-span-2">{component}</div>
      </div>
    ) : (
      <div className="flex flex-col gap-2">
        <Typography.Subtitle3>{label}</Typography.Subtitle3>
        <div>{component}</div>
      </div>
    );
  };

  return (
    <>
      <div
        className={twMerge('scaleui fixed h-full top-0 right-0', open ? 'w-[100%]' : 'w-0')}
        style={{ backgroundColor: 'black', opacity: 0.2 }}
        onClick={onOutsideClick}
      />
      <div
        className={twMerge(
          'scaleui fixed h-full top-0 right-0 flex-col flex-grow overflow-y-hidden border-l bg-neutral-0 border-l-neutral-200 transition-all',
          open ? `w-[${width}]` : 'w-0',
        )}
      >
        <div className="px-5 py-10 flex flex-col h-full justify-between">
          {inputs && inputs.length > 0 && (
            <div className="flex flex-col gap-4">
              {inputs.map(input => renderInputField(input))}
            </div>
          )}
          {component}
          <div className="flex flex-row justify-between">
            <div>
              {allowDelete && (
                <Button size="lg" disabled={disableButtons} onClick={onDelete} variant="danger">
                  Delete
                </Button>
              )}
            </div>
            <div className="flex flex-row gap-2 justify-end">
              {canSave && (
                <Button size="lg" disabled={disableButtons} onClick={onSave}>
                  {saveButtonText ?? 'Save'}
                </Button>
              )}
              <Button size="lg" variant="secondary" onClick={closeModal} disabled={disableButtons}>
                {canSave ? 'Cancel' : 'Close'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
